/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpServerItem extends models.McpServerRequest {
    getFixupPrototypeFunction() { return McpServerItem.fixupPrototype; }

    static newInstance(model: Partial<McpServerItem>): McpServerItem {
        let obj = Object.assign(new McpServerItem(), model);
        McpServerItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpServerItem>): McpServerItem {
        if (!model) return null;
        return McpServerItem.newInstance(<McpServerItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpServerItem) {
        if (!obj) return;

        models.McpServerItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpServerItem): boolean {
        if (models.McpServerRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, McpServerItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Unique server ID for MCP
     */
    sys_id: string;

    /**
     * Name of the user who registered the server.
     */
    created_by: string;

    /**
     * Timestamp when the server was registered
     */
    created_at: string;

    /**
     * Name of the user who last updated the server.
     */
    updated_by: string;

    /**
     * Timestamp when the server was last updated
     */
    updated_at: string;

}
